import { render, staticRenderFns } from "./RoutedIpv4Address.vue?vue&type=template&id=55ca00ce&"
import script from "./RoutedIpv4Address.vue?vue&type=script&lang=js&"
export * from "./RoutedIpv4Address.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports